var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer text-center text-muted",staticStyle:{"background":"#fff"}},[_vm._v("\n  All Rights Reserved by Arit Rmutl. Designed and Developed by "),_c('a',{attrs:{"href":"https://arit.rmutl.ac.th"}},[_vm._v("ARIT RMUTL")]),_vm._v(". "),_c('span',[_vm._v("Version "+_vm._s(_vm.CF.version))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-164c36ff","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 152
// module chunks = 2